import { createAction } from "@reduxjs/toolkit";
import * as types from "./types";

export const invalidJwt = createAction(types.SET_CONFIG_INVALID_TOKEN);
